module.exports = __webpack_public_path__ + "img/fr9.07992cb4.png";